/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserResignExecuteApiSettingViewModel { 
    userResignExecuteApiSettingId?: number;
    systemId?: number;
    systemName?: string;
    executeApiUrl?: string;
    requestMethod?: string;
    orderSequence?: number;
    createTime?: Date;
    createUserNo?: string;
}